import React from 'react';
import { SvgIcon } from '@mui/material';

export default function PyIcon({ active, sx, ...props }) {
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      sx={{ width: 24, height: 24, ...sx }}
      {...props}
    >
      <rect
        width="24"
        height="24"
        rx="8"
        fill={active ? '#29EDFF' : '#4520AB'}
      />
      <path
        d="M18.6296 8.54459C18.457 8.44218 18.2502 8.41167 18.0548 8.45977C17.8595 8.50787 17.6914 8.63065 17.5877 8.80109L15.9603 11.4801L14.3328 8.80109C14.2273 8.63446 14.0597 8.51542 13.8661 8.4696C13.6726 8.42378 13.4685 8.45484 13.2979 8.55609C13.1273 8.65734 13.0038 8.82069 12.9539 9.01099C12.904 9.20128 12.9318 9.40332 13.0312 9.5736L15.2008 13.1452V16.6875C15.2008 16.8864 15.2809 17.0772 15.4233 17.2178C15.5657 17.3585 15.7588 17.4375 15.9603 17.4375C16.1617 17.4375 16.3548 17.3585 16.4972 17.2178C16.6397 17.0772 16.7197 16.8864 16.7197 16.6875V13.1452L18.8893 9.5736C18.993 9.40313 19.0239 9.19895 18.9752 9.00598C18.9265 8.81302 18.8021 8.64705 18.6296 8.54459Z"
        fill="white"
      />
      <path
        d="M9.41326 8.4375H6.7585C6.55734 8.4375 6.36441 8.51652 6.22216 8.65717C6.07991 8.79782 6 8.98859 6 9.1875V16.6875C6 16.8864 6.07991 17.0772 6.22216 17.2178C6.36441 17.3585 6.55734 17.4375 6.7585 17.4375C6.95967 17.4375 7.1526 17.3585 7.29485 17.2178C7.43709 17.0772 7.51701 16.8864 7.51701 16.6875V13.6875H9.41326C10.1173 13.6875 10.7926 13.4109 11.2905 12.9187C11.7883 12.4264 12.068 11.7587 12.068 11.0625C12.068 10.3663 11.7883 9.69863 11.2905 9.20635C10.7926 8.71406 10.1173 8.4375 9.41326 8.4375ZM9.41326 12.1875H7.51701V9.9375H9.41326C9.71501 9.9375 10.0044 10.056 10.2178 10.267C10.4311 10.478 10.551 10.7641 10.551 11.0625C10.551 11.3609 10.4311 11.647 10.2178 11.858C10.0044 12.069 9.71501 12.1875 9.41326 12.1875Z"
        fill="white"
      />
    </SvgIcon>
  );
}
